"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MolecularSequence = exports.MolecularSequenceTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_MolecularSequence_ReferenceSeq_1 = require("./RTTI_MolecularSequence_ReferenceSeq");
var RTTI_MolecularSequence_Variant_1 = require("./RTTI_MolecularSequence_Variant");
var RTTI_MolecularSequence_Quality_1 = require("./RTTI_MolecularSequence_Quality");
var RTTI_MolecularSequence_Repository_1 = require("./RTTI_MolecularSequence_Repository");
var RTTI_MolecularSequence_StructureVariant_1 = require("./RTTI_MolecularSequence_StructureVariant");
var MolecularSequenceTypeKind;
(function (MolecularSequenceTypeKind) {
    MolecularSequenceTypeKind["_aa"] = "aa";
    MolecularSequenceTypeKind["_dna"] = "dna";
    MolecularSequenceTypeKind["_rna"] = "rna";
})(MolecularSequenceTypeKind = exports.MolecularSequenceTypeKind || (exports.MolecularSequenceTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_MolecularSequence = t.recursion('IMolecularSequence', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('MolecularSequence')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            type: (0, EnumType_1.createEnumType)(MolecularSequenceTypeKind, 'MolecularSequenceTypeKind'),
            _type: RTTI_Element_1.RTTI_Element,
            coordinateSystem: RTTI_integer_1.RTTI_integer,
            _coordinateSystem: RTTI_Element_1.RTTI_Element,
            patient: RTTI_Reference_1.RTTI_Reference,
            specimen: RTTI_Reference_1.RTTI_Reference,
            device: RTTI_Reference_1.RTTI_Reference,
            performer: RTTI_Reference_1.RTTI_Reference,
            quantity: RTTI_Quantity_1.RTTI_Quantity,
            referenceSeq: RTTI_MolecularSequence_ReferenceSeq_1.RTTI_MolecularSequence_ReferenceSeq,
            variant: t.array(RTTI_MolecularSequence_Variant_1.RTTI_MolecularSequence_Variant),
            observedSeq: t.string,
            _observedSeq: RTTI_Element_1.RTTI_Element,
            quality: t.array(RTTI_MolecularSequence_Quality_1.RTTI_MolecularSequence_Quality),
            readCoverage: RTTI_integer_1.RTTI_integer,
            _readCoverage: RTTI_Element_1.RTTI_Element,
            repository: t.array(RTTI_MolecularSequence_Repository_1.RTTI_MolecularSequence_Repository),
            pointer: t.array(RTTI_Reference_1.RTTI_Reference),
            structureVariant: t.array(RTTI_MolecularSequence_StructureVariant_1.RTTI_MolecularSequence_StructureVariant)
        })
    ]);
});
//# sourceMappingURL=RTTI_MolecularSequence.js.map